import { IMG_URL } from "./Constant";
export const getRandomFallbackImage = (category) => {
    const images = {
        food: [
            `${IMG_URL}/icons/default/food0.png`,
            `${IMG_URL}/icons/default/food1.png`,
            `${IMG_URL}/icons/default/food2.png`,
        ],
        drink: [
            `${IMG_URL}/icons/default/drink1.png`,
            `${IMG_URL}/icons/default/drink2.png`,
        ],
    };
    const isDrink = category && /drink/i.test(category);
    const categoryImages = isDrink ? images.drink : images.food;
    return categoryImages[Math.floor(Math.random() * categoryImages.length)];
};
